import {
  BellSimpleRinging,
  House,
  SignOut,
  UsersFour,
} from '@phosphor-icons/react'
import React, { ReactNode } from 'react'

type SidebarItem = {
  title: string
  path?: string
  icon: React.ReactNode | string | ReactNode
  iconClosed?: string // Opcional
  iconOpened?: string // Opcional
  subNav?: Array<{
    title: string
    path?: string
    icon?: string
  }>
}

export const SidebarData: SidebarItem[] = [
  {
    title: 'Home',
    path: '/home',
    icon: <House size={32} color="#003E5F" />,
    iconClosed: ``,
    iconOpened: ``,
  },
  {
    title: 'Funcionários',
    // path: '/funcionarios',
    icon: <UsersFour size={32} color="#003E5F" />,
    iconClosed: ``,
    iconOpened: ``,
    subNav: [
      {
        title: 'Funcionários',
        path: '/funcionarios',

        // icon: `icon`,
      },
      {
        title: 'Cadastro de base ',
        path: '/funcionarios/base/cadastro',
        // icon: `icon`,
      },
    ],
  },
  {
    title: 'Moradores',
    // path: '/moradores',
    icon: <UsersFour size={32} color="#003E5F" />,
    subNav: [
      {
        title: 'Moradores',
        path: '/moradores',
        // icon: `icon`,
      },
      {
        title: 'Contratos',
        path: '/moradores/contratos',
        // icon: `icon`,
      },
    ],
  },
  {
    title: 'Vigilância',
    // path: '/surveillance',
    icon: <BellSimpleRinging size={32} color="#003E5F" />,
    subNav: [
      {
        title: 'Funcionários online',
        path: '/vigilancia/funcionarios/online',
        // icon: `icon`,
      },
      {
        title: 'Sempre alerta',
        path: '/vigilancia/sempre-alerta',
        // icon: `icon`,
      },
      {
        title: 'Últimas ocorrencias',
        path: '/vigilancia/ultimas-ocorrencias',
        // icon: `icon`,
      },
      {
        title: 'Câmeras de segurança',
        path: '/vigilancia/cameras/seguranca',
        // icon: `icon`,
      },
    ],
  },
]

export const SidebarUserInfos = [
  // {
  //   title: 'Perfil',
  //   path: '/perfil',
  //   icon: <User size={32} color="#494949" />,
  // },
  {
    title: 'Log off',
    path: '/login',
    icon: <SignOut size={32} color="#BB0000" />,
  },
]
